// Module
var code = "<div> <slot></slot> </div> ";
// Exports
export default code;